import { z } from "zod";
import { zId, zIsoDate } from "./common.js";

export const zWorkKind = z.enum(["thank_you", "receipt", "delivery", "task", "recurring", "pledge"]);
export type WorkKind = z.infer<typeof zWorkKind>;
export const zWorkQuery = z.object({
  mode: z.enum(["today", "gifts", "donor"]).default("today"),
  constituentId: zId.optional(),
  kind: zWorkKind.optional(),
  owner: z.enum(["all", "mine", "unassigned"]).default("all"),
  offset: z.coerce.number().int().min(0).max(1000000).default(0),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type WorkQuery = z.infer<typeof zWorkQuery>;
export interface WorkItem {
  id: string;
  sourceId: string;
  kind: WorkKind;
  constituentId: string | null;
  constituentName: string | null;
  title: string;
  reason: string;
  dueDate: string | null;
  amount: number | null;
  assigneeId: string | null;
  assigneeName: string | null;
  taskId: string | null;
  deliveryStatus: string | null;
}
export interface WorkResult {
  items: WorkItem[];
  total: number;
  counts: Partial<Record<WorkKind, number>>;
  asOf: string;
}
export const zRecordThanks = z.object({
  method: z.enum(["phone", "email", "letter", "in_person"]),
  note: z.string().trim().min(1).max(2000),
  followUp: z.object({ title: z.string().trim().min(1).max(300), dueDate: zIsoDate, assigneeId: zId.optional() }).optional(),
});
export type RecordThanks = z.infer<typeof zRecordThanks>;
export const zRecordReceiptDelivery = z.object({ method: z.enum(["letter", "in_person"]), note: z.string().trim().min(1).max(2000) });
export const zFinishTask = z.object({
  note: z.string().trim().min(1).max(2000),
  followUp: z.object({ title: z.string().trim().min(1).max(300), dueDate: zIsoDate, assigneeId: zId.optional() }).optional(),
});
